import React from 'react';
import { LinearProgress } from '@material-ui/core';
import LogoAnimation from '@views/Testing/components/LogoAnimation'
import SVGIcon from '@components/SvgIcon';

// Icon/Logo menu
import {ReactComponent as ProjectMgIcon} from '~/assets/icons/menu/ProjectMg/ProjectManagementBlack.svg';
import {ReactComponent as DashboardIcon} from '~/assets/icons/menu/ProjectMg/DashboardBlack.svg';
import {ReactComponent as CalendarIcon} from '~/assets/icons/menu/ProjectMg/CalendarBlack.svg';
import {ReactComponent as KanbanIcon} from '~/assets/icons/menu/ProjectMg/KanbanBlack.svg';
import {ReactComponent as TimelineIcon} from '~/assets/icons/menu/ProjectMg/TimelineBlack.svg';
import {ReactComponent as GanttIcon} from '~/assets/icons/menu/ProjectMg/Gantt.svg';
// Remote Components
const DashboardPage =React.lazy(()=>import('projectmanagement/DashboardPage'))
const CalendarPage =React.lazy(()=>import('projectmanagement/CalendarPage'))
const KanbanPage =React.lazy(()=>import('projectmanagement/KanbanPage'))
const TimeLinePage =React.lazy(()=>import('projectmanagement/TimeLinePage'))
const GanttPage =React.lazy(()=>import('projectmanagement/GanttPage'))

// error boundary
import ErrorBoundary from '@components/ErrorBoundary';
import { mainColor } from '~/assets/jss/material-dashboard-react/components/sidebarStyle';

type suspense = React.LazyExoticComponent<React.ComponentType<{}>>
type withError = React.FC<{children:React.ReactNode| suspense}>
const WithSusError:withError = (props) => {
  return (
    <ErrorBoundary>
       <React.Suspense fallback={<LogoAnimation/>}>
         {props.children}
       </React.Suspense>
    </ErrorBoundary>
  );
};

const IconSize = '2.1rem';

const rootRoutes = [
  {
    parent:"Project Management",
    icon:<SVGIcon style={{color:mainColor}} fontSize={IconSize} viewBox={'0 0 1400 1400'} svg={ProjectMgIcon}/>,
    layout:'/admin',
    nestedRoutes:[
      {
        path: "/dashboard",
        name: `Dashboard`,
        rtlName: "لوحة القيادة",
        icon: <SVGIcon fontSize={IconSize} viewBox={'0 0 1400 1400'} svg={DashboardIcon}/>,
        component: <WithSusError><DashboardPage/> </WithSusError>,
        layout: "/admin",
        navBarName:'Dashboard'
      },
      {
        path: "/calendar",
        name: `Calendar`,
        rtlName: "تقويم اليوم",
        icon: <SVGIcon fontSize={IconSize} viewBox={'0 0 1400 1400'} svg={CalendarIcon}/>,
        component: <WithSusError><CalendarPage /></WithSusError>,
        layout: "/admin",
        navBarName:'Calendar'
      },
      {
        path: "/kanban",
        name: `Kanban`,
        rtlName: "كانبان",
        icon: <SVGIcon fontSize={IconSize} viewBox={'0 0 155 155'} svg={KanbanIcon}/>,
        component: <WithSusError><KanbanPage /></WithSusError>,
        layout: "/admin",
        navBarName:'Kanban'
      },
      {
        path: "/timeline",
        name: `TimeLine`,
        rtlName: "تايم لين",
        icon: <SVGIcon fontSize={IconSize} viewBox={'0 0 1400 1400'} svg={TimelineIcon}/>,
        component: <WithSusError><TimeLinePage /></WithSusError>,
        layout: "/admin",
        navBarName:'TimeLine'
      },
      {
        path: "/gantt",
        name: `Gantt`,
        rtlName: "ڨانت",
        icon:<SVGIcon style={{color:mainColor}} fontSize={IconSize} viewBox={'0 0 1400 1400'} svg={GanttIcon}/>,
        component: <WithSusError><GanttPage /></WithSusError>,
        layout: "/admin",
        navBarName:'GANTT'
      },
  ]
}
];

export default rootRoutes;